const INVALID_CAPABILITY_NAME_CHARS = /[^A-Za-z0-9_-]/g;

export const CAPABILITY_NAME_PATTERN = /^[A-Za-z0-9_-]+$/;

export function formatCapabilityName(value: string): string {
  return value
    .replace(/\s+/g, "-")
    .replace(INVALID_CAPABILITY_NAME_CHARS, "")
    .replace(/-{2,}/g, "-")
    .replace(/_{2,}/g, "_");
}

export function isValidCapabilityName(value: string): boolean {
  return CAPABILITY_NAME_PATTERN.test(value);
}
